'use client';
import useEditProfileStore from '@/components/store/editProfileModalSlice';
import useUserProfile from '@/hooks/useUserProfile';
import Dialog from '@ui/Dialog';
import Typography from '@ui/Typography';
import { authorizedServerFetch, revalidatePage } from 'actions/server.actions';
import { omit } from 'lodash-es';
import React, { useEffect, useState } from 'react';
import { FaBars, FaChevronRight, FaTimes } from 'react-icons/fa';
import { updateUserProfile } from 'stores/userActions';
import EditProfileForm from './EditProfileForm';

function EditProfileDialog(props) {
  const subHeader = useEditProfileStore((state) => state.header);
  const isOpen = useEditProfileStore((state) => state.open);
  const userData = useUserProfile();
  const setIsOpen = useEditProfileStore((state) => state.setOpen);
  const [header, setHeader] = useState(subHeader || 'Profile Information');
  const [dialogStep, setDialogStep] = useState('form');
  const [saving, setSaving] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const userProfile = userData;

  const headings = [
    'Profile Information',
    'Contact Information',
    'About',
    'Skills',
    'Causes Supported',
    'Nonprofits Supported',
    // 'Community Supported',
    'Privacy Settings',
    'Notifications',
  ];

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  function closeModal(step = 'form', open = false) {
    setDialogStep(step);
    setIsOpen(open);
  }

  const updateSaving = (save) => {
    setSaving(save);
  };

  const updateHeader = (newHeader) => {
    setHeader(newHeader);
  };

  async function onSubmit(formData, formHeader) {
    console.log('FinalData', formData);

    if (formHeader === headings[0]) {
      formData = {
        ...formData,
        first_name: formData.firstName,
        last_name: formData.lastName,
        locationDetails: formData.location,
        companyName: formData.company,
      };

      formData = omit(formData, [
        'firstName',
        'lastName',
        'location',
        'company',
      ]);
    }

    if (formHeader === headings[1]) {
      formData = {
        ...formData,
        twitterProfile: formData.twitter,
        facebookProfile: formData.facebook,
        instagramProfile: formData.instagram,
        linkedin_profile: formData.linkedin,
      };

      formData = omit(formData, [
        'twitter',
        'facebook',
        'instagram',
        'linkedin',
      ]);
    }

    const formBody = new FormData();
    formBody.append('data', JSON.stringify(formData));

    console.log('formData', formData);

    try {
      setSaving(true);
      if (formData) {
        const { data, ok } = await authorizedServerFetch(`/users/me/profile`, {
          method: 'PUT',
          body: formBody,
        });
        setSaving(false);
        console.log('data', data);
        if (ok) {
          updateUserProfile(data);
          updateHeader(formHeader);
          // revalidatePage('/profile/me');
        }
      }
    } catch (err) {
      console.log('errr', err);
    } finally {
      setSaving(false);
    }
  }

  useEffect(() => {
    if (subHeader) {
      updateHeader(subHeader);
    }
  }, [subHeader, userProfile]);

  return (
    <Dialog isOpen={isOpen} onClose={closeModal} maxWidth="lg">
      <div className="flex w-full flex-col gap-12 p-0 lg:p-0">
        <div
          className={`z-10 flex cursor-pointer items-start justify-start text-center lg:hidden`}
          onClick={toggleMenu}>
          <FaBars size={24} />
        </div>
        <div className="flex items-center justify-center text-center">
          <Typography variant="h1" className="uppercase" component="h2">
            Edit Profile
          </Typography>
          <div className="text-cyan-5xl mx-2">
            <FaChevronRight size={24} /> {/* Replace '>' with the icon */}
          </div>
          <Typography variant="h2">{header}</Typography>
        </div>

        {/* small screens */}

        <div
          className={`${
            showMenu
              ? 'fixed left-0 top-0 z-20 h-screen w-full bg-white'
              : 'hidden'
          } transform transition-transform duration-300 ease-in-out`}>
          <div className="flex justify-between gap-2 p-4 ">
            <button
              className="text-gray-500 transition-all hover:text-gray-700"
              onClick={toggleMenu}>
              <FaBars size={24} />
            </button>
            <button
              className="text-gray-500 transition-all hover:text-gray-700"
              onClick={toggleMenu}>
              <FaTimes size={24} />
            </button>
          </div>
          <div className="flex flex-col gap-2 p-4">
            {headings.map((heading) => (
              <Typography
                key={heading}
                variant="h3"
                onClick={() => {
                  updateHeader(heading);
                  toggleMenu(); // Close the menu when a heading is clicked
                }}
                className={`cursor-pointer gap-2 p-2 font-semibold`}>
                {heading}
              </Typography>
            ))}
          </div>
        </div>

        <div className="flex flex-col-reverse gap-12 lg:flex-row">
          <div className="hidden flex-col items-center gap-4 lg:flex lg:w-2/5 lg:items-start">
            {headings.map((heading) => (
              <Typography
                key={heading}
                variant="h4"
                onClick={() => updateHeader(heading)}
                className={`w-full cursor-pointer p-2 font-semibold ${
                  header === heading ? 'bg-chips-primary' : ''
                }`}>
                {heading}
              </Typography>
            ))}
          </div>

          <div className="flex flex-col gap-12 lg:w-3/5">
            {dialogStep === 'form' && (
              <EditProfileForm
                userProfile={userProfile}
                onSubmit={onSubmit}
                header={header}
                updateHeader={updateHeader}
                saving={saving}
                updateSaving={updateSaving}
                closeModal={closeModal}
              />
            )}
            {/* {dialogStep === 'success' && (
              <div className="h-full flex flex-col gap-8 items-center justify-center">
                <Typography variant="h1">Thank You!</Typography>
                <Typography variant="h3">Your Profile is updated.</Typography>
                <StyledContainedButton
                  variant="filled"
                  color="primary"
                  onClick={() => closeModal()}>
                  Close
                </StyledContainedButton>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default EditProfileDialog;
